/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FlightSegment } from './FlightSegment';
import {
    FlightSegmentFromJSON,
    FlightSegmentFromJSONTyped,
    FlightSegmentToJSON,
    FlightSegmentToJSONTyped,
} from './FlightSegment';
import type { FlightBookingDetails } from './FlightBookingDetails';
import {
    FlightBookingDetailsFromJSON,
    FlightBookingDetailsFromJSONTyped,
    FlightBookingDetailsToJSON,
    FlightBookingDetailsToJSONTyped,
} from './FlightBookingDetails';
import type { PointsAmount } from './PointsAmount';
import {
    PointsAmountFromJSON,
    PointsAmountFromJSONTyped,
    PointsAmountToJSON,
    PointsAmountToJSONTyped,
} from './PointsAmount';
import type { CurrentRateMatch } from './CurrentRateMatch';
import {
    CurrentRateMatchFromJSON,
    CurrentRateMatchFromJSONTyped,
    CurrentRateMatchToJSON,
    CurrentRateMatchToJSONTyped,
} from './CurrentRateMatch';
import type { MonitoringStatus } from './MonitoringStatus';
import {
    MonitoringStatusFromJSON,
    MonitoringStatusFromJSONTyped,
    MonitoringStatusToJSON,
    MonitoringStatusToJSONTyped,
} from './MonitoringStatus';
import type { CurrencyAmount } from './CurrencyAmount';
import {
    CurrencyAmountFromJSON,
    CurrencyAmountFromJSONTyped,
    CurrencyAmountToJSON,
    CurrencyAmountToJSONTyped,
} from './CurrencyAmount';
import type { LoyaltyProgramEnum } from './LoyaltyProgramEnum';
import {
    LoyaltyProgramEnumFromJSON,
    LoyaltyProgramEnumFromJSONTyped,
    LoyaltyProgramEnumToJSON,
    LoyaltyProgramEnumToJSONTyped,
} from './LoyaltyProgramEnum';
import type { PassengerSummary } from './PassengerSummary';
import {
    PassengerSummaryFromJSON,
    PassengerSummaryFromJSONTyped,
    PassengerSummaryToJSON,
    PassengerSummaryToJSONTyped,
} from './PassengerSummary';

/**
 * 
 * @export
 * @interface FlightReservation
 */
export interface FlightReservation {
    /**
     * 
     * @type {string}
     * @memberof FlightReservation
     */
    id?: string;
    /**
     * Search-owned booking lifecycle status; absent for imported flights and older projections.
     * @type {string}
     * @memberof FlightReservation
     */
    managedBookingStatus?: string;
    /**
     * Persisted Search booking mode; true identifies a sandbox booking. Absent when mode is unknown.
     * @type {boolean}
     * @memberof FlightReservation
     */
    managedBookingTest?: boolean;
    /**
     * Owner-scoped Search flight booking ID for Gondola-booked flights; absent for imported flights.
     * @type {string}
     * @memberof FlightReservation
     */
    managedBookingId?: string;
    /**
     * 
     * @type {string}
     * @memberof FlightReservation
     */
    emailId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FlightReservation
     */
    cancelled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FlightReservation
     */
    departureCity?: string;
    /**
     * 
     * @type {string}
     * @memberof FlightReservation
     */
    departureIata?: string;
    /**
     * 
     * @type {string}
     * @memberof FlightReservation
     */
    arrivalCity?: string;
    /**
     * 
     * @type {string}
     * @memberof FlightReservation
     */
    arrivalIata?: string;
    /**
     * 
     * @type {string}
     * @memberof FlightReservation
     */
    confirmationNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof FlightReservation
     */
    totalCost?: number;
    /**
     * 
     * @type {string}
     * @memberof FlightReservation
     */
    currency?: string;
    /**
     * 
     * @type {number}
     * @memberof FlightReservation
     */
    totalMilesRedeemed?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FlightReservation
     */
    isPointsBooking?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FlightReservation
     */
    bookingAgent?: string;
    /**
     * 
     * @type {Date}
     * @memberof FlightReservation
     */
    bookingDate?: Date;
    /**
     * 
     * @type {FlightBookingDetails}
     * @memberof FlightReservation
     */
    bookingDetails?: FlightBookingDetails;
    /**
     * 
     * @type {string}
     * @memberof FlightReservation
     */
    flightBrand?: string;
    /**
     * 
     * @type {LoyaltyProgramEnum}
     * @memberof FlightReservation
     */
    loyaltyProgram?: LoyaltyProgramEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FlightReservation
     */
    isRoundTrip?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FlightReservation
     */
    grouping?: FlightReservationGroupingEnum;
    /**
     * 
     * @type {Date}
     * @memberof FlightReservation
     */
    deletedAt?: Date;
    /**
     * 
     * @type {Array<FlightSegment>}
     * @memberof FlightReservation
     */
    flightSegments?: Array<FlightSegment>;
    /**
     * 
     * @type {string}
     * @memberof FlightReservation
     */
    tripId?: string;
    /**
     * Unique passengers on this flight reservation across all segments
     * @type {Array<PassengerSummary>}
     * @memberof FlightReservation
     */
    passengerSummary?: Array<PassengerSummary>;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof FlightReservation
     */
    currentPrice?: CurrencyAmount;
    /**
     * 
     * @type {Date}
     * @memberof FlightReservation
     */
    currentPriceUpdatedAt?: Date;
    /**
     * 
     * @type {CurrentRateMatch}
     * @memberof FlightReservation
     */
    currentPriceMatch?: CurrentRateMatch;
    /**
     * 
     * @type {number}
     * @memberof FlightReservation
     */
    currentMilesPrice?: number;
    /**
     * 
     * @type {Date}
     * @memberof FlightReservation
     */
    currentMilesPriceUpdatedAt?: Date;
    /**
     * 
     * @type {CurrentRateMatch}
     * @memberof FlightReservation
     */
    currentMilesPriceMatch?: CurrentRateMatch;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof FlightReservation
     */
    cashSavingsAmount?: CurrencyAmount;
    /**
     * 
     * @type {PointsAmount}
     * @memberof FlightReservation
     */
    pointsSavingsAmount?: PointsAmount;
    /**
     * Whether this flight is refundable
     * @type {boolean}
     * @memberof FlightReservation
     */
    refundable?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof FlightReservation
     */
    cancellableUntil?: Date;
    /**
     * The URL to the current cash price of the flight
     * @type {string}
     * @memberof FlightReservation
     */
    currentCashPriceUrl?: string;
    /**
     * The URL to the current points price of the flight
     * @type {string}
     * @memberof FlightReservation
     */
    currentPointsPriceUrl?: string;
    /**
     * 
     * @type {MonitoringStatus}
     * @memberof FlightReservation
     */
    monitoringStatus?: MonitoringStatus;
    /**
     * Human-readable explanation of the monitoring state.
     * @type {string}
     * @memberof FlightReservation
     */
    monitoringReason?: string | null;
    /**
     * Fields the user can provide to enable monitoring or AutoSave.
     * @type {Array<string>}
     * @memberof FlightReservation
     */
    missingFields?: Array<string>;
    /**
     * Whether AutoSave can be enabled for this reservation.
     * @type {boolean}
     * @memberof FlightReservation
     */
    autosaveAvailable?: boolean;
    /**
     * Whether AutoSave is ON for this flight — meaning armed AND able to run: the user enabled it globally, armed this flight, the carrier is re-bookable (Alaska/American/Delta/United, cash fare), and we hold every detail the airline re-book needs (a date of birth; for American also contact details and a loyalty number). False if ANY of those is missing, so the toggle never claims a fare is covered when it is not — see `autosave_missing_fields` for what is blocking. NOTE this is stricter than the sibling `auto_save` on HotelReservation and VehicleRental, which mean only "armed": those re-book paths never read the travel profile, so a missing date of birth does not stop them.
     * @type {boolean}
     * @memberof FlightReservation
     */
    autoSave?: boolean | null;
    /**
     * Fields blocking AutoSave specifically, distinct from `missing_fields` (which blocks monitoring — a flight can be perfectly monitorable and still not AutoSave-able). Each value routes to a surface that can actually collect it: `date_of_birth` to AutoSave setup, `phone_number`/`email` to the travel-profile editor, `loyalty_number` to the loyalty-accounts screen, and reservation fields to the Add-details dialog. Populated whenever AutoSave is available but would be blocked, whether or not the user has armed it — pair it with `auto_save` to decide whether to surface a banner. Empty when AutoSave is unblocked or unavailable.
     * @type {Array<string>}
     * @memberof FlightReservation
     */
    autosaveMissingFields?: Array<string>;
    /**
     * When AutoSave is armed but can't run (e.g. missing user info or payment method), a human-readable reason; null when not blocked.
     * @type {string}
     * @memberof FlightReservation
     */
    autosaveBlockedReason?: string | null;
    /**
     * When we last checked the current rate for this reservation.
     * @type {Date}
     * @memberof FlightReservation
     */
    monitoringLastCheckedAt?: Date | null;
}


/**
 * @export
 */
export const FlightReservationGroupingEnum = {
    Past: 'past',
    Future: 'future'
} as const;
export type FlightReservationGroupingEnum = typeof FlightReservationGroupingEnum[keyof typeof FlightReservationGroupingEnum];


/**
 * Check if a given object implements the FlightReservation interface.
 */
export function instanceOfFlightReservation(value: object): value is FlightReservation {
    return true;
}

export function FlightReservationFromJSON(json: any): FlightReservation {
    return FlightReservationFromJSONTyped(json, false);
}

export function FlightReservationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightReservation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'managedBookingStatus': json['managed_booking_status'] == null ? undefined : json['managed_booking_status'],
        'managedBookingTest': json['managed_booking_test'] == null ? undefined : json['managed_booking_test'],
        'managedBookingId': json['managed_booking_id'] == null ? undefined : json['managed_booking_id'],
        'emailId': json['email_id'] == null ? undefined : json['email_id'],
        'cancelled': json['cancelled'] == null ? undefined : json['cancelled'],
        'departureCity': json['departure_city'] == null ? undefined : json['departure_city'],
        'departureIata': json['departure_iata'] == null ? undefined : json['departure_iata'],
        'arrivalCity': json['arrival_city'] == null ? undefined : json['arrival_city'],
        'arrivalIata': json['arrival_iata'] == null ? undefined : json['arrival_iata'],
        'confirmationNumber': json['confirmation_number'] == null ? undefined : json['confirmation_number'],
        'totalCost': json['total_cost'] == null ? undefined : json['total_cost'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'totalMilesRedeemed': json['total_miles_redeemed'] == null ? undefined : json['total_miles_redeemed'],
        'isPointsBooking': json['is_points_booking'] == null ? undefined : json['is_points_booking'],
        'bookingAgent': json['booking_agent'] == null ? undefined : json['booking_agent'],
        'bookingDate': json['booking_date'] == null ? undefined : (new Date(json['booking_date'])),
        'bookingDetails': json['booking_details'] == null ? undefined : FlightBookingDetailsFromJSON(json['booking_details']),
        'flightBrand': json['flight_brand'] == null ? undefined : json['flight_brand'],
        'loyaltyProgram': json['loyalty_program'] == null ? undefined : LoyaltyProgramEnumFromJSON(json['loyalty_program']),
        'isRoundTrip': json['is_round_trip'] == null ? undefined : json['is_round_trip'],
        'grouping': json['grouping'] == null ? undefined : json['grouping'],
        'deletedAt': json['deleted_at'] == null ? undefined : (new Date(json['deleted_at'])),
        'flightSegments': json['flight_segments'] == null ? undefined : ((json['flight_segments'] as Array<any>).map(FlightSegmentFromJSON)),
        'tripId': json['trip_id'] == null ? undefined : json['trip_id'],
        'passengerSummary': json['passenger_summary'] == null ? undefined : ((json['passenger_summary'] as Array<any>).map(PassengerSummaryFromJSON)),
        'currentPrice': json['current_price'] == null ? undefined : CurrencyAmountFromJSON(json['current_price']),
        'currentPriceUpdatedAt': json['current_price_updated_at'] == null ? undefined : (new Date(json['current_price_updated_at'])),
        'currentPriceMatch': json['current_price_match'] == null ? undefined : CurrentRateMatchFromJSON(json['current_price_match']),
        'currentMilesPrice': json['current_miles_price'] == null ? undefined : json['current_miles_price'],
        'currentMilesPriceUpdatedAt': json['current_miles_price_updated_at'] == null ? undefined : (new Date(json['current_miles_price_updated_at'])),
        'currentMilesPriceMatch': json['current_miles_price_match'] == null ? undefined : CurrentRateMatchFromJSON(json['current_miles_price_match']),
        'cashSavingsAmount': json['cash_savings_amount'] == null ? undefined : CurrencyAmountFromJSON(json['cash_savings_amount']),
        'pointsSavingsAmount': json['points_savings_amount'] == null ? undefined : PointsAmountFromJSON(json['points_savings_amount']),
        'refundable': json['refundable'] == null ? undefined : json['refundable'],
        'cancellableUntil': json['cancellable_until'] == null ? undefined : (new Date(json['cancellable_until'])),
        'currentCashPriceUrl': json['current_cash_price_url'] == null ? undefined : json['current_cash_price_url'],
        'currentPointsPriceUrl': json['current_points_price_url'] == null ? undefined : json['current_points_price_url'],
        'monitoringStatus': json['monitoring_status'] == null ? undefined : MonitoringStatusFromJSON(json['monitoring_status']),
        'monitoringReason': json['monitoring_reason'] == null ? undefined : json['monitoring_reason'],
        'missingFields': json['missing_fields'] == null ? undefined : json['missing_fields'],
        'autosaveAvailable': json['autosave_available'] == null ? undefined : json['autosave_available'],
        'autoSave': json['auto_save'] == null ? undefined : json['auto_save'],
        'autosaveMissingFields': json['autosave_missing_fields'] == null ? undefined : json['autosave_missing_fields'],
        'autosaveBlockedReason': json['autosave_blocked_reason'] == null ? undefined : json['autosave_blocked_reason'],
        'monitoringLastCheckedAt': json['monitoring_last_checked_at'] == null ? undefined : (new Date(json['monitoring_last_checked_at'])),
    };
}

export function FlightReservationToJSON(json: any): FlightReservation {
    return FlightReservationToJSONTyped(json, false);
}

export function FlightReservationToJSONTyped(value?: FlightReservation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'managed_booking_status': value['managedBookingStatus'],
        'managed_booking_test': value['managedBookingTest'],
        'managed_booking_id': value['managedBookingId'],
        'email_id': value['emailId'],
        'cancelled': value['cancelled'],
        'departure_city': value['departureCity'],
        'departure_iata': value['departureIata'],
        'arrival_city': value['arrivalCity'],
        'arrival_iata': value['arrivalIata'],
        'confirmation_number': value['confirmationNumber'],
        'total_cost': value['totalCost'],
        'currency': value['currency'],
        'total_miles_redeemed': value['totalMilesRedeemed'],
        'is_points_booking': value['isPointsBooking'],
        'booking_agent': value['bookingAgent'],
        'booking_date': value['bookingDate'] == null ? value['bookingDate'] : value['bookingDate'].toISOString(),
        'booking_details': FlightBookingDetailsToJSON(value['bookingDetails']),
        'flight_brand': value['flightBrand'],
        'loyalty_program': LoyaltyProgramEnumToJSON(value['loyaltyProgram']),
        'is_round_trip': value['isRoundTrip'],
        'grouping': value['grouping'],
        'deleted_at': value['deletedAt'] == null ? value['deletedAt'] : value['deletedAt'].toISOString(),
        'flight_segments': value['flightSegments'] == null ? undefined : ((value['flightSegments'] as Array<any>).map(FlightSegmentToJSON)),
        'trip_id': value['tripId'],
        'passenger_summary': value['passengerSummary'] == null ? undefined : ((value['passengerSummary'] as Array<any>).map(PassengerSummaryToJSON)),
        'current_price': CurrencyAmountToJSON(value['currentPrice']),
        'current_price_updated_at': value['currentPriceUpdatedAt'] == null ? value['currentPriceUpdatedAt'] : value['currentPriceUpdatedAt'].toISOString(),
        'current_price_match': CurrentRateMatchToJSON(value['currentPriceMatch']),
        'current_miles_price': value['currentMilesPrice'],
        'current_miles_price_updated_at': value['currentMilesPriceUpdatedAt'] == null ? value['currentMilesPriceUpdatedAt'] : value['currentMilesPriceUpdatedAt'].toISOString(),
        'current_miles_price_match': CurrentRateMatchToJSON(value['currentMilesPriceMatch']),
        'cash_savings_amount': CurrencyAmountToJSON(value['cashSavingsAmount']),
        'points_savings_amount': PointsAmountToJSON(value['pointsSavingsAmount']),
        'refundable': value['refundable'],
        'cancellable_until': value['cancellableUntil'] == null ? value['cancellableUntil'] : value['cancellableUntil'].toISOString(),
        'current_cash_price_url': value['currentCashPriceUrl'],
        'current_points_price_url': value['currentPointsPriceUrl'],
        'monitoring_status': MonitoringStatusToJSON(value['monitoringStatus']),
        'monitoring_reason': value['monitoringReason'],
        'missing_fields': value['missingFields'],
        'autosave_available': value['autosaveAvailable'],
        'auto_save': value['autoSave'],
        'autosave_missing_fields': value['autosaveMissingFields'],
        'autosave_blocked_reason': value['autosaveBlockedReason'],
        'monitoring_last_checked_at': value['monitoringLastCheckedAt'] == null ? value['monitoringLastCheckedAt'] : value['monitoringLastCheckedAt'].toISOString(),
    };
}

